import { Form, Formik, ErrorMessage } from "formik";
import React, { useEffect, useState } from "react";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import { GET_ACCOUNTANTS, GET_ADMINS } from "../../../../api/apiAdmin";
import { GET_ENTERPRISES, UPDATE_ENTERPRISE } from "../../../../api/apiEmpresas";
import InputField from "../../../atoms/InputField";
import Button from "../../../atoms/Button";
import { reginmenFiscalOptions } from "../../../../data/regimenFiscalData";
import Select from "react-select";

const ModalEditEnterprise = ({ onClose, refetch, empresa }) => {
    const [accountants, setAccountants] = useState();
    const [empresas, setEmpresas] = useState();
    const [admins, setAdmins] = useState();

    useEffect(() => {
        const getData = async () => {
            try {
                const accountantsData = await GET_ACCOUNTANTS();
                setAccountants(accountantsData);
            } catch (errorAccountants) {
                console.error(errorAccountants);
            }
            try {
                const adminsData = await GET_ADMINS();
                const filterAdmins = adminsData.filter(admin => !admin.isSuperAdmin)
                setAdmins(filterAdmins);
            } catch (errorAdmins) {
                console.error(errorAdmins);
            }
            const enterprisesData = await GET_ENTERPRISES();
            try {
                setEmpresas(enterprisesData);
            } catch (errorEnterprises) {
                console.error(errorEnterprises);
            }
        };
        getData();
    }, []);

    const getEnterpriseCountForAccountant = (accountantId) => {
        return empresas?.filter((enterprise) => enterprise.accountantId === accountantId).length || 0;
    };

    const combinedOptions = [
        ...(accountants ? accountants.map(a => ({
            label: `${a.name} - ${getEnterpriseCountForAccountant(a.id)} empresa(s)`,
            value: `accountant-${a.id}`,
        })) : []),
        ...(admins ? admins.map(a => ({
            label: a.name,
            value: `admin-${a.id}`,
        })) : [])
    ];

    const validate = (values) => {
        const errors = {};

        if (!values.name) { errors.name = "El nombre es requerido"; }
        if (!values.rfc) { errors.rfc = "El RFC es requerido"; }
        if (!values.address) { errors.address = "La direccion es requerido"; }
        return errors;
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        const newValues = {
            ...values,
            name: values.name.toUpperCase(),
            address: values.address.toUpperCase(),
            accountantId: null,
            adminId: null,
            lawyerId: values.lawyerId === "" ? null : values.lawyerId,
            c_RegimenFiscal: values.c_RegimenFiscal.map((r) => r.value).join(","),
        };

        if (values.personResponsible) {
            const [type, id] = values.personResponsible.split("-");
            if (type === "accountant") {
                newValues.accountantId = id;
            } else if (type === "admin") {
                newValues.adminId = id;
            }
        };

        try {
            await UPDATE_ENTERPRISE(empresa.id, newValues);
            toast.success("Registro exitoso");
            refetch();
            onClose();
        } catch(error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setSubmitting(false);
        }
    };

    let personResponsible = "";
    if (empresa?.accountantId) {
        personResponsible = `accountant-${empresa.accountantId}`;
    } else if (empresa?.adminId) {
        personResponsible = `admin-${empresa.adminId}`;
    }

    const initialValues = {
        name: empresa.name || "",
        address: empresa.address || "",
        cellphone: empresa.cellphone || "",
        rfc: empresa?.rfc || "",
        personResponsible,
        c_RegimenFiscal: empresa.c_RegimenFiscal
        ? empresa.c_RegimenFiscal.split(",").map((clave) => {
            const found = reginmenFiscalOptions.find((opt) => opt.value === parseInt(clave));
            return found || { value: parseInt(clave), label: clave };
        })
        : [],
        email_client: empresa.email_client || "",
        name_rl: empresa.name_rl || "",
        rfc_rl: empresa.rfc_rl || "",
        isAccountingClient: empresa.isAccountingClient || false,
		isTaxDefenseClient: empresa.isTaxDefenseClient || false,
    };

    return(
        <div className="w-full">
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validate={validate}
            >
                {({ isSubmitting, setFieldValue, values }) => (
                    <Form className="w-full flex flex-col items-center">
                        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-2">
                            <InputField name="name" label="Nombre de la empresa" placeholder="Nombre de la empresa" capitalize/>
                            <InputField name="address" label="Dirección" placeholder="Direccion" capitalize/>
                            <InputField name="rfc" label="RFC EMPRESA" placeholder="RFC"/>
                            <InputField name="cellphone" label="Numero de telefono" placeholder="Número de teléfono" capitalize type="number" />
                            <div className="w-full relative text-left">
                                <label className="text-black text-sm font-bold">
                                    Contador
                                </label>
                                <Select
                                    name="personResponsible"
                                    options={combinedOptions}
                                    className="border border-black rounded-lg"
                                    classNamePrefix="select"
                                    onChange={(option) => setFieldValue("personResponsible", option ? option.value : "")}
                                    value={combinedOptions.find(opt => opt.value === values.personResponsible) || null}
                                    placeholder="Selecciona un contador"
                                />
                                <ErrorMessage name="personResponsible">
                                    {(message) => (
                                        <div className="absolute right-0 text-sm text-[#e73842]">
                                            {message}
                                        </div>
                                    )}
                                </ErrorMessage>
                            </div>
                            <InputField name="rfc_rl" label="RFC RL" placeholder="RFC RL"/>
                            <InputField name="name_rl" label="Nombre RL" placeholder="Nombre RL"/>
                            <InputField name="email_client" label="Email de la empresa" placeholder="Email"/>
                            <div className="col-span-2 flex gap-4">
                                <label className="w-full flex items-center gap-2">
                                    <input
                                    type="checkbox"
                                    name="isAccountingClient"
                                    checked={values.isAccountingClient}
                                    onChange={() => setFieldValue("isAccountingClient", !values.isAccountingClient)}
                                    />
                                    Cliente de contabilidad
                                </label>

                                <label className="w-full flex items-center gap-2">
                                    <input
                                    type="checkbox"
                                    name="isTaxDefenseClient"
                                    checked={values.isTaxDefenseClient}
                                    onChange={() => setFieldValue("isTaxDefenseClient", !values.isTaxDefenseClient)}
                                    />
                                    Cliente de defensa fiscal
                                </label>
                            </div>
                            <div className="w-full">
                                <label className="block text-sm font-medium text-gray-700">
                                    Régimen Fiscal
                                </label>
                                <Select
                                    isMulti
                                    name="c_RegimenFiscal"
                                    options={reginmenFiscalOptions}
                                    className="basic-multi-select border border-black rounded-lg"
                                    classNamePrefix="select"
                                    onChange={(selectedOptions) => setFieldValue("c_RegimenFiscal", selectedOptions)}
                                    value={values.c_RegimenFiscal}
                                />
                            </div>
                        </div>
                            <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Actualizar"} type="submit" disabled={isSubmitting} bgColor="blue" />
                    </Form>
                )}
            </Formik>
        </div>
    )
};

export default ModalEditEnterprise;